module.exports = __webpack_public_path__ + "img/数据看板.a9777528.png";